import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'

import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'

@Component({
  selector: 'col-logo-operadora',
  templateUrl: './logo-operadora.component.html'
})

export class LogoOperadoraComponent implements OnChanges {
  @Input() operadora: OperadoraDeMaquina
  @Input() width?: string
  @Input() height?: string
  // tslint:disable-next-line:no-input-rename
  @Input('class') cssClass?: string

  style: any
  imagePath: string
  imageAlt: string

  constructor() {
    this.style = {
      width: '75px'
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('operadora' in changes) {
      this.updateImg()
    }

    if ('width' in changes || 'height' in changes) {
      this.updateStyle()
    }
  }

  private updateImg() {
    this.imagePath = this.getImagePath()
    this.imageAlt = this.operadora.nome
  }

  private updateStyle() {
    this.style = { width: '75px' }

    if (!isEmptyValue(this.width)) {
      this.style.width = this.width
    }

    if (!isEmptyValue(this.height)) {
      this.style.height = this.height
    }
  }

  private getImagePath() {
    const id = this.operadora.nome && this.operadora.nome.toLowerCase().trim().replace(/ /g, '_')
    return `https://cdn.alterdata.com.br/pack/packup/Content/images/cartoes/estabelecimento_${id}.png`
  }
}

function isEmptyValue(value: any) {
  return value === undefined || value === null
}



// WEBPACK FOOTER //
// ./src/app/common/logo-operadora/logo-operadora.component.ts